import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import type { FC, SVGProps } from 'react';

export interface SidebarToggleIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

export const SidebarToggleIcon: FC<SidebarToggleIconProps> = ({
  size = 14,

  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M1.39583 14C1.01194 14 0.683333 13.8633 0.41 13.59C0.136667 13.3167 0 12.9881 0 12.6042V1.39583C0 1.01194 0.136667 0.683333 0.41 0.41C0.683333 0.136667 1.01194 0 1.39583 0H12.6042C12.9881 0 13.3167 0.136667 13.59 0.41C13.8633 0.683333 14 1.01194 14 1.39583V12.6042C14 12.9881 13.8633 13.3167 13.59 13.59C13.3167 13.8633 12.9881 14 12.6042 14H1.39583ZM5.5 12.5H12.5V1.5H5.5V12.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export interface AvailableToolsIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const AvailableToolsIcon: FC<AvailableToolsIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M15.0833 17.5L10.5625 12.9792L11.9792 11.5625L16.5 16.0833L15.0833 17.5ZM3.91667 17.5L2.5 16.0833L8.08333 10.5L6.75 9.16667L5.95833 9.95833L4.875 8.875V10.3333L4.33333 10.875L2 8.54167L2.54167 8H4L3.25 7.22917L6.25 4.22917C6.48611 3.99306 6.75347 3.8125 7.05208 3.6875C7.35069 3.5625 7.66667 3.5 8 3.5C8.33333 3.5 8.64931 3.5625 8.94792 3.6875C9.24653 3.8125 9.51389 3.99306 9.75 4.22917L7.9375 6.02083L8.91667 7L8.16667 7.75L9.5 9.08333L11.2292 7.35417C11.1597 7.17361 11.1042 6.99306 11.0625 6.8125C11.0208 6.63194 11 6.44444 11 6.25C11 5.48611 11.2674 4.83681 11.8021 4.30208C12.3368 3.76736 12.9861 3.5 13.75 3.5C13.9444 3.5 14.1319 3.52083 14.3125 3.5625C14.4931 3.60417 14.6736 3.65972 14.8542 3.72917L13.0417 5.54167L14.4583 6.95833L16.2708 5.14583C16.3542 5.3125 16.4132 5.48958 16.4479 5.67708C16.4826 5.86458 16.5 6.05556 16.5 6.25C16.5 7.01389 16.2326 7.65972 15.6979 8.1875C15.1632 8.71528 14.5139 8.97917 13.75 8.97917C13.5556 8.97917 13.3681 8.96181 13.1875 8.92708C13.0069 8.89236 12.8264 8.83333 12.6458 8.75L3.91667 17.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CopyIcon: FC<AvailableToolsIconProps> = ({
  size = 20,
  ...props
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_7044_872)">
        <path
          d="M13.3333 6.66683V5.00016C13.3333 4.55814 13.1577 4.13421 12.8451 3.82165C12.5325 3.50909 12.1086 3.3335 11.6666 3.3335H4.99992C4.55789 3.3335 4.13397 3.50909 3.82141 3.82165C3.50885 4.13421 3.33325 4.55814 3.33325 5.00016V11.6668C3.33325 12.1089 3.50885 12.5328 3.82141 12.8453C4.13397 13.1579 4.55789 13.3335 4.99992 13.3335H6.66659M6.66659 8.3335C6.66659 7.89147 6.84218 7.46755 7.15474 7.15499C7.4673 6.84242 7.89122 6.66683 8.33325 6.66683H14.9999C15.4419 6.66683 15.8659 6.84242 16.1784 7.15499C16.491 7.46755 16.6666 7.89147 16.6666 8.3335V15.0002C16.6666 15.4422 16.491 15.8661 16.1784 16.1787C15.8659 16.4912 15.4419 16.6668 14.9999 16.6668H8.33325C7.89122 16.6668 7.4673 16.4912 7.15474 16.1787C6.84218 15.8661 6.66659 15.4422 6.66659 15.0002V8.3335Z"
          stroke={isDark ? '#9E9E9E' : '#757575'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7044_872">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RetryIcon: FC<AvailableToolsIconProps> = ({
  size = 20,
  ...props
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 19 14"
      fill="none"
      {...props}
    >
      <path
        d="M15 3.33333L11.6667 6.66667H14.1667C14.1667 9.425 11.925 11.6667 9.16667 11.6667C8.325 11.6667 7.525 11.4583 6.83333 11.0833L5.61667 12.3C6.64167 12.95 7.85833 13.3333 9.16667 13.3333C12.85 13.3333 15.8333 10.35 15.8333 6.66667H18.3333L15 3.33333ZM4.16667 6.66667C4.16667 3.90833 6.40833 1.66667 9.16667 1.66667C10.0083 1.66667 10.8083 1.875 11.5 2.25L12.7167 1.03333C11.6917 0.383333 10.475 0 9.16667 0C5.48333 0 2.5 2.98333 2.5 6.66667H0L3.33333 10L6.66667 6.66667H4.16667Z"
        fill={isDark ? '#9E9E9E' : '#757575'}
      />
    </svg>
  );
};

export const SendIconDisabled: FC<AvailableToolsIconProps> = ({
  size = 20,
  ...props
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <rect
        width="20"
        height="20"
        rx="4"
        fill={isDark ? '#616161' : '#D9D9D9'}
      />
      <path
        d="M9.25 16V6.875L5.0625 11.0625L4 10L10 4L16 10L14.9375 11.0625L10.75 6.875V16H9.25Z"
        fill={isDark ? '#333333' : '#9E9E9E'}
      />
    </svg>
  );
};

export const SendIconEnabled: FC<AvailableToolsIconProps> = ({
  size = 20,
  ...props
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <rect
        width="20"
        height="20"
        rx="4"
        fill={isDark ? '#BDBDBD' : '#D9D9D9'}
      />
      <path
        d="M9.25 16V6.875L5.0625 11.0625L4 10L10 4L16 10L14.9375 11.0625L10.75 6.875V16H9.25Z"
        fill="#333333"
      />
    </svg>
  );
};

export const DeleteIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M5.83301 17.5C5.37467 17.5 4.98231 17.3368 4.65592 17.0104C4.32954 16.684 4.16634 16.2917 4.16634 15.8333V5H3.33301V3.33333H7.49967V2.5H12.4997V3.33333H16.6663V5H15.833V15.8333C15.833 16.2917 15.6698 16.684 15.3434 17.0104C15.017 17.3368 14.6247 17.5 14.1663 17.5H5.83301ZM14.1663 5H5.83301V15.8333H14.1663V5ZM7.49967 14.1667H9.16634V6.66667H7.49967V14.1667ZM10.833 14.1667H12.4997V6.66667H10.833V14.1667Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const StopIcon: FC<AvailableToolsIconProps> = ({
  size = 20,
  ...props
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill={isDark ? '#9E9E9E' : '#BDBDBD'} />
      <rect
        x="5"
        y="6"
        width="10"
        height="8"
        rx="1"
        fill={isDark ? '#333333' : '#4A4A4A'}
      />
    </svg>
  );
};
